// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"GN-z","modalContent":"HN-z","header":"IN-z","close":"JN-z"};